import { stats } from '@/mocks/categories';

export default function TrustSection() {
  return (
    <section className="relative bg-background-50 py-16 md:py-24 px-4 md:px-10 overflow-hidden">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="flex-1">
            <h2 className="font-heading text-foreground-900 text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-10">
              Por que usar
              <br />
              <span className="text-secondary-500">CSSBuy</span>
              <br />
              Spreadsheet?
            </h2>

            <div className="grid grid-cols-3 gap-6 md:gap-10">
              {stats.map((stat, index) => (
                <div key={stat.label} className={index < 2 ? 'border-r border-background-300/60 pr-4 md:pr-8' : ''}>
                  <p className="text-secondary-500 text-3xl md:text-4xl lg:text-5xl font-black tracking-tight mb-2">
                    {stat.value}
                  </p>
                  <p className="text-foreground-500 text-xs md:text-sm leading-snug">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 relative">
            <div className="relative w-full h-64 md:h-80 lg:h-96 rounded-2xl overflow-hidden bg-gradient-to-br from-secondary-100 via-secondary-50 to-background-100">
              <div className="absolute top-10 left-8 w-32 h-32 rounded-3xl bg-secondary-200/50 rotate-12"></div>
              <div className="absolute top-20 right-10 w-24 h-24 rounded-full bg-secondary-300/40"></div>
              <div className="absolute bottom-12 left-16 w-40 h-28 rounded-2xl bg-secondary-100/60 -rotate-6"></div>
              <div className="absolute bottom-8 right-14 w-20 h-36 rounded-3xl bg-secondary-200/40 rotate-45"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-36 h-36 rounded-full bg-secondary-300/30"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}